/**
 * Gets hash parts from URL
 * @returns {string[]|null} Hash parts or null
 */
export function getHashParts() {
  const hash = window.location.hash;
  if (!hash || !hash.startsWith("#/")) return null;
  return hash.slice(2).split("/");
}

/**
 * Gets shared info from URL hash
 * @returns {object|null} Shared info with uid and lang
 */
export function getSharedInfo() {
  const parts = getHashParts();
  if (!parts || parts[0] === "join") return null;
  if (parts[0] && parts[0].length > 5) return { uid: parts[0], lang: parts[1] || "en", wishlistId: parts[2] || null };
  return null;
}
/**
 * Gets join info from URL hash
 * @returns {object|null} Join info with familyId
 */
export function getJoinInfo() {
  const parts = getHashParts();
  if (parts && parts[0] === "join" && parts[1]) return { 
    familyId: parts[1],
    familyName: parts[2] ? decodeURIComponent(parts[2]) : null
  };
  return null;
}
